import React, { useEffect, useState } from "react";
import api from "@/api";
import { useAuth } from "@/context/AuthContext";

export function useSchools() {
  const { user } = useAuth();
  const [schools, setSchools] = useState([]);
  useEffect(() => {
    if (user?.role === "admin") api.get("/schools").then((r) => setSchools(r.data)).catch(() => {});
  }, [user]);
  return schools;
}

export default function SchoolFilter({ value, onChange, schools }) {
  return (
    <select
      data-testid="school-filter"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="px-4 py-2 rounded-xl bg-amber-50 border border-amber-400/30 text-stone-800 text-sm focus:outline-none focus:border-amber-400"
    >
      <option value="">كل المدارس</option>
      {schools.map((s) => (
        <option key={s.id} value={s.id}>{s.name}</option>
      ))}
    </select>
  );
}
